import { Box, HStack, Text } from "@chakra-ui/react"
import { UI } from "components"

export default function Option({ title, tagline, image_src, colorPalette = 'gray', selected = false, ...props}){
    return(
    <UI.Pressable {...props}>
        <Box py={3} px={4} borderWidth={1} borderRadius={4} borderColor={selected?`${colorPalette}.fg`:null} background={selected?`${colorPalette}.muted`:null}>
            <HStack gap={4}>
                <Box>
                    <UI.Avatar src={image_src} colorPalette={colorPalette} />
                </Box>
                <Box>
                    <Text>{title}</Text>
                    <Text fontSize="xs" color="GrayText">{tagline}</Text>
                </Box>
            </HStack>
        </Box>
    </UI.Pressable>
    )
}